import { API_CONSULT } from 'Constants/client-modules';
import { WEBCHAT } from 'Constants/normalize-module';
import { consultSchema } from 'Schemas/schemas';
import * as ACTION_TYPES from './types';

export function consultHistoryRetrieve(conversationId, params = {}) {
  return {
    types: [
      ACTION_TYPES.CONSULT_HISTORY_RETRIEVE_REQUESTED,
      ACTION_TYPES.CONSULT_HISTORY_RETRIEVE_SUCCEED,
      ACTION_TYPES.CONSULT_HISTORY_RETRIEVE_FAILED,
    ],
    promise: client => client.get(`/conversations/${conversationId}/consults`, { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: [consultSchema],
      },
      module: WEBCHAT,
    },
  };
}
